// Rich mock dataset for JB Notify HVAC CRM prototype

export const technicians = [
  {
    id: 'TCH-01',
    name: 'Marcus Alvarez',
    role: 'Senior Technician',
    initials: 'MA',
    certifications: ['NATE Certified', 'EPA 608 Universal', 'Honeywell Installer Pro'],
    availability: 'On Route',
    serviceArea: 'North Metro',
    rating: 4.9,
    completedThisMonth: 42,
    avgResponseHrs: 2.3,
    activeTickets: 4,
  },
  {
    id: 'TCH-02',
    name: 'Priya Natarajan',
    role: 'Lead Diagnostic Tech',
    initials: 'PN',
    certifications: ['NATE Certified', 'BPI Building Analyst', 'IAQ Specialist'],
    availability: 'Available',
    serviceArea: 'Downtown + East',
    rating: 4.8,
    completedThisMonth: 38,
    avgResponseHrs: 1.9,
    activeTickets: 3,
  },
  {
    id: 'TCH-03',
    name: 'Derrick Owens',
    role: 'Technician',
    initials: 'DO',
    certifications: ['NATE Certified', 'EPA 608 Type II'],
    availability: 'On Job',
    serviceArea: 'Southside',
    rating: 4.7,
    completedThisMonth: 31,
    avgResponseHrs: 2.6,
    activeTickets: 5,
  },
  {
    id: 'TCH-04',
    name: 'Hannah Kobayashi',
    role: 'Technician',
    initials: 'HK',
    certifications: ['EPA 608 Universal', 'Commercial HVAC'],
    availability: 'Available',
    serviceArea: 'West + Suburbs',
    rating: 4.9,
    completedThisMonth: 35,
    avgResponseHrs: 2.1,
    activeTickets: 2,
  },
  {
    id: 'TCH-05',
    name: 'Liam O’Brien',
    role: 'Apprentice Technician',
    initials: 'LO',
    certifications: ['EPA 608 Type I'],
    availability: 'Off Today',
    serviceArea: 'North Metro',
    rating: 4.6,
    completedThisMonth: 18,
    avgResponseHrs: 3.2,
    activeTickets: 1,
  },
];

export const plans = [
  {
    id: 'PLAN-BASIC',
    tier: 'Basic Monitoring',
    priceMonthly: 14,
    features: ['24/7 device monitoring', 'Monthly system summary', 'Email alerts'],
    color: 'info',
  },
  {
    id: 'PLAN-PREV',
    tier: 'Preventive Maintenance',
    priceMonthly: 29,
    features: [
      '2 tune-ups / year',
      'Priority scheduling',
      'Filter program',
      'All Basic features',
    ],
    color: 'healthy',
  },
  {
    id: 'PLAN-PREMIUM',
    tier: 'Premium Comfort Protection',
    priceMonthly: 49,
    features: [
      '2 tune-ups + IAQ check',
      '10% parts + labor discount',
      'No overtime charges',
      'Smart diagnostic alerts',
    ],
    color: 'warning',
  },
  {
    id: 'PLAN-COMMERCIAL',
    tier: 'Commercial / Advanced Monitoring',
    priceMonthly: 149,
    features: [
      'Multi-site dashboard',
      'Quarterly inspections',
      'SLA response times',
      'Runtime analytics export',
    ],
    color: 'critical',
  },
];

// 25 customer + device records
const rawCustomers = [
  ['Eleanor Whitaker', '412 Magnolia Ln', 'Brookline, MA 02446', 'eleanor.w@mail.com', '(617) 555-0132', 'PLAN-PREMIUM', 'Honeywell T10 Pro', 'Healthy', 92, 'cool', 'running', 72, 48, 73, 'online', '2m ago', 'TCH-02', 48200, false],
  ['Jerome Ballard', '88 Chestnut Hill Rd', 'Newton, MA 02458', 'j.ballard@mail.com', '(617) 555-0187', 'PLAN-PREV', 'Honeywell ElitePRO S1200', 'Watchlist', 74, 'cool', 'running', 74, 58, 72, 'online', '5m ago', 'TCH-01', 31500, true],
  ['Ava Chen', '1204 Beacon St Unit 4B', 'Brookline, MA 02446', 'ava.chen@mail.com', '(617) 555-0144', 'PLAN-BASIC', 'Honeywell T9', 'Healthy', 88, 'auto', 'idle', 71, 45, 71, 'online', '1m ago', 'TCH-02', 14800, false],
  ['Samuel Okafor', '67 Pine Ridge Ct', 'Wellesley, MA 02481', 'sam.okafor@mail.com', '(781) 555-0110', 'PLAN-PREMIUM', 'Honeywell Home Prestige IAQ', 'Critical', 41, 'cool', 'running', 78, 64, 72, 'online', '3m ago', 'TCH-03', 58200, true],
  ['Rosa Martinez', '2203 Harborview Dr', 'Quincy, MA 02169', 'rosa.m@mail.com', '(617) 555-0178', 'PLAN-PREV', 'Honeywell VisionPRO 8000', 'Healthy', 95, 'off', 'idle', 70, 44, 70, 'online', '30s ago', 'TCH-04', 27400, false],
  ['Nathaniel Park', '9 Alderwood Ave', 'Needham, MA 02492', 'n.park@mail.com', '(781) 555-0155', 'PLAN-PREV', 'Honeywell T10 Pro', 'Maintenance', 68, 'cool', 'running', 73, 52, 72, 'online', '6m ago', 'TCH-01', 19900, true],
  ['Maya Brennan', '310 Lakeside Way', 'Lexington, MA 02420', 'maya.b@mail.com', '(781) 555-0166', 'PLAN-PREMIUM', 'Honeywell Home Prestige IAQ', 'Watchlist', 77, 'auto', 'fan', 71, 49, 71, 'online', '4m ago', 'TCH-02', 42100, true],
  ['Terrence Wu', '56 Orchard Terrace', 'Arlington, MA 02476', 't.wu@mail.com', '(617) 555-0193', 'PLAN-BASIC', 'Honeywell T9', 'Offline', 0, 'cool', 'offline', 0, 0, 72, 'offline', '2h 14m ago', 'TCH-01', 9400, true],
  ['Isabella Romano', '1501 Summit Crest', 'Wellesley, MA 02481', 'isabella.r@mail.com', '(781) 555-0121', 'PLAN-PREMIUM', 'Honeywell ElitePRO S1200', 'Healthy', 90, 'cool', 'running', 72, 46, 72, 'online', '1m ago', 'TCH-04', 51200, false],
  ['Kenji Matsuda', '778 River Bend Rd', 'Cambridge, MA 02140', 'k.matsuda@mail.com', '(617) 555-0109', 'PLAN-PREV', 'Honeywell VisionPRO 8000', 'Watchlist', 72, 'cool', 'aux', 75, 55, 72, 'online', '8m ago', 'TCH-03', 22700, true],
  ['Evangeline Ross', '24 Highfield Circle', 'Belmont, MA 02478', 'e.ross@mail.com', '(617) 555-0138', 'PLAN-PREMIUM', 'Honeywell T10 Pro', 'Healthy', 86, 'auto', 'idle', 71, 47, 71, 'online', '2m ago', 'TCH-02', 38400, false],
  ['Micah Townsend', '89 Willow Brook Ln', 'Newton, MA 02458', 'm.townsend@mail.com', '(617) 555-0175', 'PLAN-BASIC', 'Honeywell T9', 'Critical', 38, 'cool', 'error', 79, 66, 72, 'online', '12m ago', 'TCH-01', 11300, true],
  ['Saoirse Byrne', '3302 Chelsea Square', 'Somerville, MA 02143', 's.byrne@mail.com', '(617) 555-0184', 'PLAN-PREV', 'Honeywell Home Prestige IAQ', 'Healthy', 93, 'auto', 'idle', 70, 43, 70, 'online', '45s ago', 'TCH-04', 33600, false],
  ['Dmitri Volkov', '611 Oak Grove Ave', 'Medford, MA 02155', 'd.volkov@mail.com', '(617) 555-0161', 'PLAN-PREMIUM', 'Honeywell ElitePRO S1200', 'Watchlist', 70, 'cool', 'running', 74, 54, 72, 'online', '3m ago', 'TCH-03', 29800, true],
  ['Naomi Fitzgerald', '155 Brookside Pkwy', 'Brookline, MA 02446', 'n.fitz@mail.com', '(617) 555-0148', 'PLAN-PREV', 'Honeywell T10 Pro', 'Maintenance', 65, 'auto', 'running', 72, 50, 71, 'online', '5m ago', 'TCH-02', 24200, true],
  ['Everett Kim', '912 Ridge Walk', 'Natick, MA 01760', 'e.kim@mail.com', '(508) 555-0172', 'PLAN-BASIC', 'Honeywell T9', 'Healthy', 84, 'cool', 'running', 72, 48, 72, 'online', '2m ago', 'TCH-04', 17100, false],
  ['Aria Sullivan', '47 Elmwood Rd', 'Watertown, MA 02472', 'a.sullivan@mail.com', '(617) 555-0119', 'PLAN-PREMIUM', 'Honeywell Home Prestige IAQ', 'Watchlist', 76, 'auto', 'fan', 71, 51, 71, 'online', '4m ago', 'TCH-02', 46700, true],
  ['Julian Hargrove', '208 Crescent Hill', 'Lexington, MA 02420', 'j.hargrove@mail.com', '(781) 555-0127', 'PLAN-PREV', 'Honeywell VisionPRO 8000', 'Critical', 45, 'cool', 'running', 77, 63, 72, 'online', '9m ago', 'TCH-03', 31100, true],
  ['Priscilla Okonkwo', '1820 Hemlock Glen', 'Winchester, MA 01890', 'p.okonkwo@mail.com', '(781) 555-0194', 'PLAN-PREMIUM', 'Honeywell ElitePRO S1200', 'Healthy', 91, 'cool', 'idle', 71, 46, 71, 'online', '1m ago', 'TCH-04', 52900, false],
  ['Owen Bergstrom', '744 Maple Knoll', 'Milton, MA 02186', 'o.bergstrom@mail.com', '(617) 555-0106', 'PLAN-BASIC', 'Honeywell T9', 'Offline', 0, 'heat', 'offline', 0, 0, 68, 'offline', '1h 2m ago', 'TCH-01', 8700, true],
  ['Leilani Akana', '59 Seabreeze Ln', 'Hingham, MA 02043', 'l.akana@mail.com', '(781) 555-0133', 'PLAN-PREV', 'Honeywell T10 Pro', 'Healthy', 89, 'auto', 'idle', 72, 47, 72, 'online', '2m ago', 'TCH-04', 26500, false],
  ['Garrett Mulroney', '1100 Stonegate Cir', 'Needham, MA 02492', 'g.mulroney@mail.com', '(781) 555-0168', 'PLAN-PREMIUM', 'Honeywell Home Prestige IAQ', 'Watchlist', 73, 'cool', 'running', 73, 57, 72, 'online', '6m ago', 'TCH-02', 44200, true],
  ['Celeste Dubois', '331 Linden Park Ave', 'Brookline, MA 02446', 'c.dubois@mail.com', '(617) 555-0188', 'PLAN-PREV', 'Honeywell VisionPRO 8000', 'Maintenance', 67, 'cool', 'running', 73, 53, 72, 'online', '7m ago', 'TCH-03', 28900, true],
  ['Hudson Reyes', '502 Pinecrest Dr', 'Newton, MA 02458', 'h.reyes@mail.com', '(617) 555-0141', 'PLAN-BASIC', 'Honeywell T9', 'Healthy', 87, 'auto', 'idle', 71, 45, 71, 'online', '3m ago', 'TCH-02', 15800, false],
  ['Mirela Constantin', '1776 Liberty Hill Rd', 'Concord, MA 01742', 'm.constantin@mail.com', '(978) 555-0157', 'PLAN-PREMIUM', 'Honeywell ElitePRO S1200', 'Critical', 44, 'cool', 'running', 80, 68, 72, 'online', '11m ago', 'TCH-01', 37500, true],
];

function healthBand(score) {
  if (score === 0) return 'Offline';
  if (score >= 85) return 'Healthy';
  if (score >= 70) return 'Watchlist';
  if (score >= 60) return 'Maintenance';
  return 'Critical';
}

export const customers = rawCustomers.map((r, i) => {
  const id = `CUS-${String(1001 + i)}`;
  const deviceId = `HW-${r[6].split(' ').slice(-1)[0].toUpperCase().replace(/[^A-Z0-9]/g, '')}-${String(2401 + i)}`;
  return {
    id,
    name: r[0],
    address: r[1],
    city: r[2],
    email: r[3],
    phone: r[4],
    planId: r[5],
    plan: plans.find((p) => p.id === r[5])?.tier || 'None',
    deviceModel: r[6],
    deviceId,
    healthBand: r[7],
    healthScore: r[8],
    mode: r[9],
    equipmentStatus: r[10],
    indoorTemp: r[11],
    humidity: r[12],
    setpoint: r[13],
    connection: r[14],
    lastCheckIn: r[15],
    preferredTechId: r[16],
    lifetimeValue: r[17],
    hasActiveAlert: r[18],
    lastServiceDate: new Date(Date.now() - (30 + i * 7) * 864e5).toISOString().slice(0, 10),
    nextScheduledService: new Date(Date.now() + (20 + (i % 6) * 9) * 864e5).toISOString().slice(0, 10),
    installedEquipment: [
      r[6],
      i % 3 === 0 ? 'Carrier Infinity 26 AC' : i % 3 === 1 ? 'Trane XV20i Heat Pump' : 'Lennox SL280V Furnace',
      i % 2 === 0 ? 'Aprilaire 700 Humidifier' : 'Honeywell F300 Air Cleaner',
    ],
    notes: i % 4 === 0 ? 'Prefers morning appointments. Gate code 4412.' : i % 4 === 1 ? 'Dog on premises, friendly.' : i % 4 === 2 ? 'Recently installed new ductwork.' : 'Long-time customer since 2018.',
  };
});

export const devices = customers.map((c) => ({
  id: c.deviceId,
  customerId: c.id,
  customer: c.name,
  address: `${c.address}, ${c.city}`,
  model: c.deviceModel,
  connection: c.connection,
  indoorTemp: c.indoorTemp,
  humidity: c.humidity,
  setpoint: c.setpoint,
  mode: c.mode,
  equipmentStatus: c.equipmentStatus,
  healthScore: c.healthScore,
  healthBand: healthBand(c.healthScore),
  lastCheckIn: c.lastCheckIn,
  hasActiveAlert: c.hasActiveAlert,
  preferredTechId: c.preferredTechId,
  outdoorTemp: 84 + ((c.healthScore % 5) - 2),
  runtimeTodayMin: 120 + (c.healthScore % 100),
  runtimeWeekHr: 22 + (c.healthScore % 18),
  stage: c.equipmentStatus === 'aux' ? 'Aux Heat Stage 2' : c.equipmentStatus === 'running' ? 'Stage 1 Cooling' : 'Idle',
  fanStatus: c.equipmentStatus === 'fan' ? 'Continuous' : c.equipmentStatus === 'running' ? 'Auto / On' : 'Auto / Off',
}));

// Alert types catalog
export const alertTypes = [
  'System short cycling',
  'Cooling runtime abnormal',
  'Humidity control failure',
  'Possible clogged filter',
  'Failure to reach setpoint',
  'Device offline',
  'Repeated aux heat usage',
  'Room sensor imbalance',
  'VOC spike',
  'High indoor humidity',
  'Maintenance due',
  'Compressor performance concern',
  'Fan running unusually long',
  'Customer comfort complaint risk',
];

const severityFromHealth = (band) => {
  if (band === 'Critical' || band === 'Offline') return 'critical';
  if (band === 'Maintenance') return 'warning';
  if (band === 'Watchlist') return 'watchlist';
  return 'informational';
};

// Build alerts from devices that have active alerts, plus a few extras
const alertSeeds = customers
  .filter((c) => c.hasActiveAlert)
  .map((c, i) => {
    const pool = {
      Critical: ['Compressor performance concern', 'Failure to reach setpoint', 'System short cycling', 'High indoor humidity'],
      Offline: ['Device offline'],
      Maintenance: ['Maintenance due', 'Possible clogged filter', 'Cooling runtime abnormal'],
      Watchlist: ['Humidity control failure', 'Room sensor imbalance', 'Fan running unusually long', 'Repeated aux heat usage', 'VOC spike'],
    };
    const list = pool[c.healthBand] || pool.Watchlist;
    const type = list[i % list.length];
    const sev = severityFromHealth(c.healthBand);
    return {
      id: `ALT-${String(9001 + i)}`,
      customerId: c.id,
      customer: c.name,
      address: `${c.address}, ${c.city}`,
      deviceId: c.deviceId,
      deviceModel: c.deviceModel,
      type,
      severity: sev,
      confidence: 72 + ((i * 7) % 26),
      createdAgo: `${(i % 6) + 1}h ago`,
      detectedIssue: buildDetected(type),
      aiSummary: buildSummary(type, c),
      recommended: buildRecommended(type),
      assignedTechnician: c.preferredTechId,
      status: i % 5 === 0 ? 'reviewed' : 'new',
    };
  });

function buildDetected(type) {
  const m = {
    'System short cycling': 'Compressor cycling 14 times/hr vs baseline 4-6',
    'Cooling runtime abnormal': 'Runtime 38% above 30-day baseline for similar outdoor temps',
    'Humidity control failure': 'Indoor humidity trending up 8% over 24h despite cooling demand',
    'Possible clogged filter': 'Reduced ΔT across coil + extended runtime',
    'Failure to reach setpoint': 'Indoor temp 4-6°F above setpoint for 3+ hours',
    'Device offline': 'No check-in received in 60+ minutes',
    'Repeated aux heat usage': 'Aux heat engaged 9 times in last 24h (baseline: 1)',
    'Room sensor imbalance': 'Remote sensor drift exceeds 3°F for 4+ hours',
    'VOC spike': 'IAQ VOC index crossed 180 ppb sustained',
    'High indoor humidity': 'RH > 62% for 6+ hours',
    'Maintenance due': 'No service visit logged in 11 months',
    'Compressor performance concern': 'Unusual amp draw signature + long stage-2 runs',
    'Fan running unusually long': 'Blower runtime 2.4x baseline with no cooling demand',
    'Customer comfort complaint risk': 'Setpoint overrides increased 5x this week',
  };
  return m[type] || 'Anomaly detected in performance telemetry';
}

function buildSummary(type, c) {
  return `Diagnostic model flags ${type.toLowerCase()} on ${c.deviceModel}. Evidence: humidity ${c.humidity}%, indoor ${c.indoorTemp}°F (setpoint ${c.setpoint}°F), runtime elevated. Likely contributing factors include airflow restriction, refrigerant charge drift, or control logic misconfiguration.`;
}

function buildRecommended(type) {
  const m = {
    'System short cycling': 'Dispatch diagnostic within 48h. Check refrigerant charge, TXV operation, and thermostat cycle settings.',
    'Cooling runtime abnormal': 'Schedule AC tune-up. Inspect evaporator coil, filter, and charge.',
    'Humidity control failure': 'Verify fan mode + dehumidification setpoint. Inspect drain pan and coil.',
    'Possible clogged filter': 'Recommend filter replacement and IAQ upgrade upsell.',
    'Failure to reach setpoint': 'Priority dispatch. Possible refrigerant undercharge or airflow restriction.',
    'Device offline': 'Contact customer for Wi-Fi/power check. Re-provision device if needed.',
    'Repeated aux heat usage': 'Inspect heat pump reversing valve, defrost cycle, and outdoor sensor.',
    'Room sensor imbalance': 'Recalibrate or relocate remote sensor. Check mounting.',
    'VOC spike': 'Recommend IAQ assessment + UV / media upgrade upsell.',
    'High indoor humidity': 'Verify fan operation. Consider whole-home dehumidifier quote.',
    'Maintenance due': 'Outreach call for annual tune-up scheduling.',
    'Compressor performance concern': 'Priority dispatch. Check capacitor, contactor, amp draw.',
    'Fan running unusually long': 'Inspect fan mode + control wiring. Verify setpoint logic.',
    'Customer comfort complaint risk': 'Proactive outreach + comfort optimization visit.',
  };
  return m[type] || 'Schedule diagnostic visit';
}

export const alerts = alertSeeds;

// Service tickets
const ticketStatuses = ['new', 'scheduled', 'assigned', 'in_progress', 'waiting_parts', 'completed', 'cancelled'];
export const tickets = customers.slice(0, 16).map((c, i) => {
  const alert = alerts.find((a) => a.customerId === c.id);
  const status = ticketStatuses[i % ticketStatuses.length];
  return {
    id: `TKT-${String(3001 + i)}`,
    customerId: c.id,
    customerName: c.name,
    address: `${c.address}, ${c.city}`,
    deviceId: c.deviceId,
    deviceModel: c.deviceModel,
    issue: alert ? alert.type : 'Seasonal tune-up',
    alertSource: alert ? alert.id : null,
    priority: c.healthBand === 'Critical' || c.healthBand === 'Offline' ? 'High' : c.healthBand === 'Maintenance' ? 'Medium' : 'Low',
    technician: c.preferredTechId,
    scheduledAt: new Date(Date.now() + ((i % 9) + 1) * 864e5).toISOString().slice(0, 10) + ' ' + ['09:00', '11:00', '13:00', '15:30'][i % 4],
    estRevenue: 185 + ((i * 37) % 720),
    status,
    createdAt: new Date(Date.now() - (i * 3 + 1) * 864e5).toISOString(),
    notes: [
      { author: 'System', text: 'Ticket auto-created from diagnostic alert.', ts: '2d ago' },
      { author: 'Dispatcher', text: 'Customer prefers afternoon window.', ts: '1d ago' },
    ],
    partsNeeded: i % 3 === 0 ? ['16x25x4 media filter', 'Run capacitor 45/5 mfd'] : i % 3 === 1 ? ['Blower wheel cleaning kit'] : [],
    checklist: [
      'Verify reported symptoms against diagnostic data',
      'Inspect filter and airflow path',
      'Check refrigerant levels and pressures',
      'Validate thermostat wiring and sensor calibration',
      'Review runtime + cycle data post-service',
    ],
    resolution: status === 'completed' ? 'Replaced run capacitor and cleaned evaporator coil. Runtime returned to baseline within 2h.' : null,
  };
});

// Helper exports for Analytics page
export function countByBand(devicesArr) {
  const init = { Healthy: 0, Watchlist: 0, Maintenance: 0, Critical: 0, Offline: 0 };
  devicesArr.forEach((d) => { init[d.healthBand] = (init[d.healthBand] || 0) + 1; });
  return init;
}

export function mrr(customersArr, plansArr) {
  return customersArr.reduce((sum, c) => {
    const p = plansArr.find((pp) => pp.id === c.planId);
    return sum + (p ? p.priceMonthly : 0);
  }, 0);
}
